//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    components: {
        AQCheckbox
    },
    props: {},
    data() {
        return {
            labelText: "Label",
            option: false,
            typeList: [
                { value: true, label: "true" },
                { value: false, label: "false" },
                { value: null, label: "nulll" }
            ],
            type: false,
            type1: false,
            clickValue: "one",
            clickValue1: "two",
            clickValue2: "three",
            lista2: ["one"]
        };
    },
    computed: {
    },
    methods: {
        showNotification(bool) {
            this.type = bool.value;
        },
        changeValue(event) {
            this.type = event;
        },
        changeValueObject(event) {
            this.lista2.push(event);
        }
    }

};
